import React, { Component } from 'react';
import './styles.css';
class ProductionProgramLayout extends Component {
	render() {
		return (
			<div className="production-program-layout">{this.props.children}</div>
		);
	}
}

export default ProductionProgramLayout;
